import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
// Redux Form
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import {
  Row,
  Col,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
} from 'react-bootstrap';
import cx from 'classnames';
import { injectIntl, FormattedMessage } from 'react-intl';

import DateRange from '../DateRange';
import BillDetails from './BillDetails';
import BookingButton from './BookingButton';

import { bookingProcess } from '../../../actions/booking/bookingProcess';
import messages from '../../../locale/messages';

import bt from '../../../components/commonStyle.css';
import s from './Calendar.css';
class BookingForm extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    personCapacity: PropTypes.number.isRequired,
    country: PropTypes.string,
    basePrice: PropTypes.number.isRequired,
    cleaningPrice: PropTypes.number,
    tax: PropTypes.number,
    currency: PropTypes.string,
    monthlyDiscount: PropTypes.number,
    weeklyDiscount: PropTypes.number,
    customDiscounts: PropTypes.string,
    extraGuestThreshold: PropTypes.number,
    extraGuestFee: PropTypes.number,
    cautionDeposit: PropTypes.number,
    minNight: PropTypes.number,
    maxNight: PropTypes.number,
    minStayWeekend: PropTypes.bool,
    maxDaysNotice: PropTypes.string,
    loading: PropTypes.bool,
    availability: PropTypes.bool,
    maximumStay: PropTypes.bool,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    blockedDates: PropTypes.array,
    isHost: PropTypes.bool.isRequired,
    guests: PropTypes.number,
    serviceFees: PropTypes.shape({
      guest: PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    base: PropTypes.string.isRequired,
    rates: PropTypes.object.isRequired,
    bookingType: PropTypes.string.isRequired,
    bookingLoading: PropTypes.bool,
    formatMessage: PropTypes.any,
    account: PropTypes.shape({
      userBanStatus: PropTypes.number,
    })
  };
  static defaultProps = {
    blockedDates: [],
    availability: true,
    maximumStay: false,
    minimumStay: false,
    startDate: null,
    endDate: null,
    guests: 1,
    personCapacity: 0,
    country: ''
  };

  constructor(props) {
    super(props);
    this.state = {
      personCapacityData: [],
    };
  }
  
  UNSAFE_componentWillMount() {
    const { listingFields } = this.props;
    if (listingFields != undefined) {
      this.setState({ personCapacityData: listingFields.personCapacity });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields, guests } = nextProps;
    const { personCapacity, change } = this.props;
    if (listingFields != undefined) {
      this.setState({ personCapacityData: listingFields.personCapacity });
    }
    let guestCount = guests > personCapacity ? personCapacity : guests;
    change('guests', guestCount)
  }

  // Helper function to check if a date is a weekend (Friday or Saturday night)
  isWeekendNight(date) {
    if (!date) return false;
    const dayOfWeek = moment(date).day(); // 0 = Sunday, 5 = Friday, 6 = Saturday
    return dayOfWeek === 6; // Friday or Saturday nights
  }

  // Check if booking includes weekend nights
  bookingIncludesWeekend(startDate, endDate) {
    if (!startDate || !endDate) return false;

    const start = moment(startDate);
    const end = moment(endDate);
    const dayDifference = end.diff(start, 'days');

    // Check each night in the booking range
    for (let i = 0; i < dayDifference; i++) {
      const currentDate = moment(start).add(i, 'day');
      if (this.isWeekendNight(currentDate)) {
        return true;
      }
    }
    return false;
  }

  checkSpecialPriceMinStayConflict() {
    const { startDate, endDate, blockedDates } = this.props;

    if (!startDate || !endDate || !blockedDates || !Array.isArray(blockedDates)) {
      return false;
    }

    const startDateString = moment(startDate).format('YYYY-MM-DD');
    const selectedNights = moment(endDate).diff(moment(startDate), 'days');

    const matchingDate = blockedDates.find(day =>
      moment(day.blockedDates).format('YYYY-MM-DD') === startDateString
    );

    if (matchingDate && matchingDate.specialPriceMinStay && matchingDate.specialPriceMinStay > 0) {
      return selectedNights < matchingDate.specialPriceMinStay;
    }

    return false;
  }

  checkWeekendMinStayConflict() {
    const { startDate, endDate, minStayWeekend, weekendPrice } = this.props;

    if (!startDate || !endDate) {
      return false;
    }

    // Only apply if minStayWeekend is enabled and weekendPrice is set
    if (!minStayWeekend || !weekendPrice || weekendPrice <= 0) {
      return false;
    }



    // Check if selected nights is less than 2 (hardcoded weekend minimum)
    const WEEKEND_MIN_NIGHTS = 2;
    // const selectedNights = moment(endDate).diff(moment(startDate), 'days');
    const selectedNights = moment(endDate).diff(moment(startDate), 'days');
    return this.isWeekendNight(startDate) && selectedNights < WEEKEND_MIN_NIGHTS;
  }

  getEffectiveMinNight() {
    const { startDate, blockedDates, minNight, minStayWeekend, weekendPrice, endDate } = this.props;

    if (!startDate || !blockedDates || !Array.isArray(blockedDates)) {
      return minNight;
    }

    const startDateString = moment(startDate).format('YYYY-MM-DD');

    // Priority 1: Check for special price min stay
    const matchingDate = blockedDates.find(day =>
      moment(day.blockedDates).format('YYYY-MM-DD') === startDateString
    );

    if (matchingDate && matchingDate.specialPriceMinStay && matchingDate.specialPriceMinStay > 0) {
      return matchingDate.specialPriceMinStay;
    }

    // Priority 2: Check for weekend minimum stay (2 nights)
    if (minStayWeekend && weekendPrice && weekendPrice > 0) {
      // Check if booking includes weekend
      // if (endDate) {
      //   return 2; // Hardcoded 2-night minimum for weekend bookings
      // }
      // If only start date selected, check if it's a weekend
      if (!endDate && this.isWeekendNight(startDate)) {
        return 2;
      }
    }

    // Priority 3: Base minimum nights
    return minNight;
  }

  renderFormControlSelect({ input, label, meta: { touched, error }, children, className }) {
    return (
      <div>
        <FormControl componentClass="select" {...input} className={className} >
          {children}
        </FormControl>
      </div>
    );
  }
  renderGuests(personCapacity) {
    const { personCapacityData } = this.state;
    const rows = [];
    for (let i = 1; i <= personCapacity; i++) {
      rows.push(<option key={i} value={i}>{i} {i > 1 ? personCapacityData && personCapacityData.length > 0 && personCapacityData[0] && personCapacityData[0].otherItemName : personCapacityData && personCapacityData.length > 0 && personCapacityData[0] && personCapacityData[0].itemName}</option>);
    }
    return rows;
  }
  render() {
    const { formatMessage } = this.props.intl;
    const { id, personCapacity, basePrice, cleaningPrice, tax, currency, isHost, bookingType, taxRate, isHostServiceEligible } = this.props;
    const { monthlyDiscount, weeklyDiscount, customDiscounts, extraGuestThreshold, extraGuestFee, weekendPrice, minStayWeekend, cautionDeposit, minNight, maxNight, maxDaysNotice } = this.props;
    const { isLoading, availability, maximumStay, guests, startDate, endDate, account, blockedDates, minimumStay, country } = this.props;
    const { bookingProcess, serviceFees, base, rates, bookingLoading, initialValues } = this.props;
    const isDateChosen = startDate != null && endDate != null || false;
    let userBanStatusValue;
    if (account) {
      const { account: { userBanStatus } } = this.props;
      userBanStatusValue = userBanStatus;
    }

    return (
      <Form>
        <FormGroup className={s.noMargin}>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <label className={cx(s.guestText, 'guestTextRTL')}>
                <FormattedMessage {...messages.dates} />
              </label>
              <span className={cx('viewListingDate')}>
                <DateRange
                  listId={id}
                  minimumNights={minNight}
                  maximumNights={maxNight}
                  blockedDates={blockedDates}
                  formName={'BookingForm'}
                  maxDaysNotice={maxDaysNotice}
                  country={country}
                  weekendPrice={weekendPrice}
                  minStayWeekend={minStayWeekend}
                />
              </span>
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <ControlLabel className={cx(s.guestText, 'guestTextRTL')}><FormattedMessage {...messages.howManyGuest} /></ControlLabel>
              <Field
                name="guests"
                component={this.renderFormControlSelect}
                className={cx(s.formControlSelect, bt.commonControlSelect, 'viewGuestCount', s.guestFormControlSelect)}
              >
                {this.renderGuests(personCapacity)}
              </Field>
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          {
            !isLoading && maximumStay && isDateChosen && !userBanStatusValue && <div className={cx(s.bookItMessage, s.spaceTop3)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.maximumStay} /> {maxNight} {maxNight > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
              </p>
            </div>
          }
          {
            !isLoading && (minimumStay || this.checkSpecialPriceMinStayConflict() || this.checkWeekendMinStayConflict()) && isDateChosen && !userBanStatusValue && <div
              className={cx(s.bookItMessage, s.spaceTop3)}
            >
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.minimumNightStay} />  {this.getEffectiveMinNight()} {this.getEffectiveMinNight() > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
              </p>
            </div>
          }

          {
            !isLoading && !availability && isDateChosen && !userBanStatusValue && <div className={cx(s.bookItMessage, s.spaceTop3)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.hostErrorMessage2} />
              </p>
            </div>
          }
        </FormGroup>
        {
          !isLoading && !maximumStay && !minimumStay && !this.checkSpecialPriceMinStayConflict() && !this.checkWeekendMinStayConflict() && availability && isDateChosen && !userBanStatusValue && <BillDetails
            basePrice={basePrice}
            cleaningPrice={cleaningPrice}
            tax={tax}
            currency={currency}
            monthlyDiscount={monthlyDiscount}
            weeklyDiscount={weeklyDiscount}
            customDiscounts={customDiscounts}
            extraGuestThreshold={extraGuestThreshold}
            extraGuestFee={extraGuestFee}
            weekendPrice={weekendPrice}
            cautionDeposit={cautionDeposit}
            guests={guests}
            startDate={startDate}
            endDate={endDate}
            serviceFees={serviceFees}
            base={base}
            rates={rates}
            taxRate={taxRate}
          />
        }
        <BookingButton
          listId={id}
          startDate={startDate}
          endDate={endDate}
          guests={!isNaN(guests) ? guests : 1}
          bookingProcess={bookingProcess}
          availability={availability}
          isDateChosen={isDateChosen}
          userBanStatus={userBanStatusValue}
          basePrice={basePrice}
          isHost={isHost}
          bookingType={bookingType}
          bookButton={!isLoading && !maximumStay && !minimumStay && !this.checkSpecialPriceMinStayConflict() && !this.checkWeekendMinStayConflict() && availability && isDateChosen && !userBanStatusValue}
          bookingLoading={bookingLoading}
          maximumStay={maximumStay}
          taxRate={taxRate}
          minimumStay={minimumStay}
          isHostServiceEligible={isHostServiceEligible}
        />
      </Form>
    );
  }
}
BookingForm = reduxForm({
  form: 'BookingForm', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(BookingForm);
// Decorate with connect to read form values
const selector = formValueSelector('BookingForm'); // <-- same as form name
const mapState = state => ({
  isLoading: state.viewListing.isLoading,
  availability: state.viewListing.availability,
  maximumStay: state.viewListing.maximumStay,
  minimumStay: state.viewListing.minimumStay,
  startDate: selector(state, 'startDate'),
  endDate: selector(state, 'endDate'),
  guests: Number(selector(state, 'guests')),
  isHostServiceEligible: selector(state, 'isHostServiceEligible'),
  account: state.account.data,
  serviceFees: state.book.serviceFees,
  base: state.currency.base,
  rates: state.currency.rates,
  bookingLoading: state.book.bookingLoading,
  listingFields: state.listingFields.data,
});
const mapDispatch = {
  bookingProcess,
  change
};
export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(BookingForm)));
